// Generated by scripts/harness/compile-harness-snapshot.mjs
// Do not edit by hand.
export const harnessSnapshot = {
  "generated_at": "2026-06-16T13:19:08.684Z",
  "source_files": {
    "agent_runs": ".codex-harness/state/agent-runs.jsonl",
    "task_queue": ".codex-harness/state/task-queue.jsonl",
    "blockers": ".codex-harness/state/blockers.jsonl",
    "cost_ledger": ".codex-harness/state/cost-ledger.jsonl",
    "acceptance_reports": ".codex-harness/reports/acceptance/*.json"
  },
  "agent_runs": {
    "today": 37,
    "week": 230,
    "total": 1413,
    "by_agent": {
      "engineer": 106,
      "intake_pm": 433,
      "release": 237,
      "metrics": 12,
      "radar-ready-executor": 182,
      "data": 49,
      "qa": 2,
      "requirement_drafter": 99,
      "requirement_reviewer": 114,
      "requirement_publisher": 65,
      "intake-pm": 2,
      "requirement_quality_experiment": 2,
      "visual_review_gate": 96,
      "followup_proposer": 4,
      "ceo": 2,
      "requirement_quality_loop": 6,
      "product": 2
    },
    "by_status": {
      "passed": 1301,
      "blocked": 110,
      "started": 2
    },
    "success_rate": 0.92,
    "recent": [
      {
        "id": "run-1781614290545",
        "agent": "data",
        "task_id": "REQ-178",
        "status": "passed",
        "started_at": "2026-06-16T12:51:30.545Z",
        "completed_at": "2026-06-16T12:51:40.018Z",
        "checks": [
          "goal_claim",
          "feishu_in_progress_writeback"
        ],
        "blocker": "",
        "local_only": false
      },
      {
        "id": "run-1781614204018",
        "agent": "intake_pm",
        "task_id": "requirement-docs",
        "status": "blocked",
        "started_at": "2026-06-16T12:50:04.018Z",
        "completed_at": "2026-06-16T12:50:04.063Z",
        "checks": [
          "local_requirement_scan",
          "prd_render",
          "feishu_requirement_update"
        ],
        "blocker": "Missing Chinese requirement specs for: alpha-task-A, alpha-task-D, content-task-case-boundary, content-task-case-tag, product-task-harness-link, REQ-001, REQ-002, REQ-003, REQ-004, REQ-006, REQ-008, REQ-146, REQ-147, REQ-148, REQ-149, REQ-150, REQ-151, REQ-152",
        "local_only": false
      },
      {
        "id": "run-1781614162912",
        "agent": "data",
        "task_id": "REQ-178",
        "status": "blocked",
        "started_at": "2026-06-16T12:49:22.912Z",
        "completed_at": "2026-06-16T12:49:28.393Z",
        "checks": [
          "goal_claim",
          "feishu_in_progress_writeback"
        ],
        "blocker": "Requirement not found in Feishu: REQ-178 | repository=kunhai-88/ai-podcast-radar | branch=codex/req172-podcast-content-refresh | auth=gh_authenticated | suggestion=No PR detected; pass --github-pr or open a PR for this branch.",
        "local_only": false
      },
      {
        "id": "run-1781614145052",
        "agent": "radar-ready-executor",
        "task_id": "REQ-178",
        "status": "passed",
        "started_at": "2026-06-16T12:49:05.052Z",
        "completed_at": "2026-06-16T12:49:05.089Z",
        "checks": [
          "queue_scan",
          "single_ready_selection",
          "requirement_doc_parse",
          "context_write",
          "goal_write",
          "selected:REQ-178"
        ],
        "blocker": "",
        "local_only": false
      },
      {
        "id": "run-1781612731696",
        "agent": "data",
        "task_id": "REQ-177",
        "status": "passed",
        "started_at": "2026-06-16T12:25:31.696Z",
        "completed_at": "2026-06-16T12:25:46.583Z",
        "checks": [
          "topic_maps",
          "pdf_layout",
          "pdf_forbidden_scan",
          "markdown_clean",
          "asset_plan",
          "r2_upload"
        ],
        "blocker": "",
        "local_only": false
      },
      {
        "id": "run-1781612522836",
        "agent": "visual_review_gate",
        "task_id": "visual-review",
        "status": "passed",
        "started_at": "2026-06-16T12:22:02.834Z",
        "completed_at": "2026-06-16T12:22:02.836Z",
        "checks": [
          "score:95",
          "conclusion:pass",
          "css_reviewed",
          "screenshots_checked",
          "public_surface_checked"
        ],
        "blocker": "",
        "local_only": false
      },
      {
        "id": "run-1781610486424",
        "agent": "data",
        "task_id": "REQ-177",
        "status": "passed",
        "started_at": "2026-06-16T11:48:06.424Z",
        "completed_at": "2026-06-16T11:48:17.828Z",
        "checks": [
          "goal_claim",
          "feishu_in_progress_writeback"
        ],
        "blocker": "",
        "local_only": false
      },
      {
        "id": "run-1781610324551",
        "agent": "data",
        "task_id": "REQ-177",
        "status": "blocked",
        "started_at": "2026-06-16T11:45:24.551Z",
        "completed_at": "2026-06-16T11:45:32.970Z",
        "checks": [
          "goal_claim",
          "feishu_in_progress_writeback"
        ],
        "blocker": "Requirement not found in Feishu: REQ-177 | repository=kunhai-88/ai-podcast-radar | branch=codex/req172-podcast-content-refresh | auth=gh_authenticated | suggestion=No PR detected; pass --github-pr or open a PR for this branch.",
        "local_only": false
      },
      {
        "id": "run-1781610300802",
        "agent": "radar-ready-executor",
        "task_id": "REQ-177",
        "status": "passed",
        "started_at": "2026-06-16T11:45:00.802Z",
        "completed_at": "2026-06-16T11:45:00.835Z",
        "checks": [
          "queue_scan",
          "single_ready_selection",
          "requirement_doc_parse",
          "context_write",
          "goal_write",
          "selected:REQ-177"
        ],
        "blocker": "",
        "local_only": false
      },
      {
        "id": "run-1781610072535",
        "agent": "requirement_reviewer",
        "task_id": "requirement-spec-review",
        "status": "passed",
        "started_at": "2026-06-16T11:41:12.535Z",
        "completed_at": "2026-06-16T11:41:12.542Z",
        "checks": [
          "draft_load",
          "quality_standard_check",
          "conflict_review",
          "publish_gate",
          "conclusion:needs_revision",
          "score:90"
        ],
        "blocker": "",
        "local_only": false
      }
    ]
  },
  "requirements": {
    "total": 106,
    "by_status": {
      "qa_passed": 59,
      "documented": 1,
      "archived": 18,
      "blocked": 5,
      "triaged": 10,
      "released": 12,
      "in_progress": 1
    },
    "by_owner": {
      "engineer": 66,
      "intake_pm": 7,
      "release": 4,
      "metrics": 2,
      "data": 24,
      "qa": 2,
      "content": 1
    },
    "ready": 0,
    "in_progress": 1,
    "blocked": 5,
    "released": 12,
    "items": [
      {
        "id": "alpha-task-A",
        "title": "[alpha-task-A] 追加 MVP-alpha 运行记录",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "engineer",
        "requirement_doc": "docs/product/requirements/REQ-111.md",
        "production_url": "/harness/",
        "blocker": ""
      },
      {
        "id": "alpha-task-D",
        "title": "[alpha-task-D] 追加 MVP-alpha 经验记录",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "engineer",
        "requirement_doc": "docs/product/requirements/REQ-111.md",
        "production_url": "/harness/",
        "blocker": ""
      },
      {
        "id": "content-task-case-boundary",
        "title": "[content-task] add boundary to the Viptunnel case",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "engineer",
        "requirement_doc": "docs/product/requirements/REQ-112.md",
        "production_url": "/harness/",
        "blocker": ""
      },
      {
        "id": "content-task-case-tag",
        "title": "[content-task] add harness-smoke tag to a published case",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "engineer",
        "requirement_doc": "docs/product/requirements/REQ-112.md",
        "production_url": "/harness/",
        "blocker": ""
      },
      {
        "id": "product-task-harness-link",
        "title": "[product-task] expose the harness dashboard link in homepage config",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "engineer",
        "requirement_doc": "docs/product/requirements/REQ-110.md",
        "production_url": "/harness/",
        "blocker": ""
      },
      {
        "id": "REQ-001",
        "title": "Create the first public issue radar dashboard",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "engineer",
        "requirement_doc": "docs/product/requirements/REQ-001.md",
        "production_url": "",
        "blocker": ""
      },
      {
        "id": "REQ-002",
        "title": "Connect Feishu Requirements and Tasks tables",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "intake_pm",
        "requirement_doc": "docs/product/requirements/REQ-002.md",
        "production_url": "",
        "blocker": ""
      },
      {
        "id": "REQ-003",
        "title": "Publish GitHub repository and CI validation",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "release",
        "requirement_doc": "docs/product/requirements/REQ-003.md",
        "production_url": "",
        "blocker": ""
      },
      {
        "id": "REQ-004",
        "title": "Deploy Cloudflare Pages production site",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "release",
        "requirement_doc": "docs/product/requirements/REQ-004.md",
        "production_url": "",
        "blocker": ""
      },
      {
        "id": "REQ-005",
        "title": "Define Codex agent lanes and scheduled automations",
        "status": "documented",
        "priority": "P0",
        "owner_agent": "intake_pm",
        "requirement_doc": "docs/product/requirements/REQ-005.md",
        "production_url": "https://ai-podcast-radar-web.pages.dev/",
        "blocker": ""
      },
      {
        "id": "REQ-006",
        "title": "Create Cloudflare-native product metrics loop",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "metrics",
        "requirement_doc": "docs/product/requirements/REQ-006.md",
        "production_url": "",
        "blocker": ""
      },
      {
        "id": "REQ-007",
        "title": "将控制台模拟数据替换为真实飞书与 D1 状态",
        "status": "archived",
        "priority": "P0",
        "owner_agent": "intake_pm",
        "requirement_doc": "docs/product/requirements/REQ-007.md",
        "production_url": "",
        "blocker": "Archived during current MVP cleanup: old internal control-plane items are frozen for MVP v1 and covered by REQ-110 dashboard/manual Harness operations. See docs/product/mvp-v1.md section 7 and docs/product/roadmap.md."
      },
      {
        "id": "REQ-008",
        "title": "Add Product Requirement Analysis agent loop",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "intake_pm",
        "requirement_doc": "docs/product/requirements/REQ-008.md",
        "production_url": "",
        "blocker": ""
      },
      {
        "id": "REQ-009",
        "title": "将 Cloudflare 指标日报写回飞书",
        "status": "qa_passed",
        "priority": "P0",
        "owner_agent": "metrics",
        "requirement_doc": "docs/product/requirements/REQ-009.md",
        "production_url": "",
        "blocker": ""
      },
      {
        "id": "REQ-010",
        "title": "建立播客语料来源目录导入",
        "status": "archived",
        "priority": "P0",
        "owner_agent": "data",
        "requirement_doc": "docs/product/requirements/REQ-010.md",
        "production_url": "",
        "blocker": "Archived during current MVP cleanup: these data/source coverage items are absorbed by REQ-100, REQ-101, or REQ-110 and should not stay in the current triage lane. See docs/product/mvp-v1.md section 7."
      },
      {
        "id": "REQ-011",
        "title": "计算 AI 议题热度与播客讨论排行",
        "status": "archived",
        "priority": "P0",
        "owner_agent": "data",
        "requirement_doc": "docs/product/requirements/REQ-011.md",
        "production_url": "",
        "blocker": "Archived during current MVP cleanup: these topic/ranking/information-architecture items conflict with the case + insight MVP object model. See docs/product/mvp-v1.md section 7 and docs/product/roadmap.md old requirement disposition."
      }
    ]
  },
  "blockers": {
    "total": 75,
    "active": [
      {
        "id": "blocker-1781614204077",
        "task_id": "requirement-docs",
        "source": "requirements-docs",
        "message": "Missing Chinese requirement specs for: alpha-task-A, alpha-task-D, content-task-case-boundary, content-task-case-tag, product-task-harness-link, REQ-001, REQ-002, REQ-003, REQ-004, REQ-006, REQ-008, REQ-146, REQ-147, REQ-148, REQ-149, REQ-150, REQ-151, REQ-152",
        "created_at": "2026-06-16T12:50:04.077Z"
      },
      {
        "id": "blocker-1781071514305",
        "task_id": "REL-20260610-060414",
        "source": "release",
        "message": "npm run deploy:prod failed: Command failed: npm run deploy:prod\nnpm error code EAGAIN\nnpm error syscall spawn sh\nnpm error path <repo>\nnpm error errno -35\nnpm error spawn sh EAGAIN\nnpm error command sh -c node scripts/content/build-podcast-r2-assets.mjs\nnpm error A complete log of this run can be found in: <local-path>\n; npm run cloudflare:check failed: Command failed: npm run cloudflare:check\nnpm error code EAGAIN\nnpm error syscall spawn sh\nnpm error path <repo>\nnpm error errno -35\nnpm error spawn sh EAGAIN\nnpm error command sh -c node scripts/integrations/cloudflare/check-pages.mjs\nnpm error A complete log of this run can be found in: <local-path>\n",
        "created_at": "2026-06-10T06:05:14.287Z"
      },
      {
        "id": "blocker-1780999520827",
        "task_id": "REL-20260609-100450",
        "source": "release",
        "message": "npm run validate failed: Command failed: npm run validate\n[harness:validate] failed\n- REQ-158 has invalid status: complete\n",
        "created_at": "2026-06-09T10:05:20.804Z"
      },
      {
        "id": "blocker-1780625515174",
        "task_id": "REL-20260605-021154",
        "source": "release",
        "message": "Production deploy requires a clean worktree. Changed files: ai-podcast-radar/.codex-harness/progress/REQ-143/acceptance-status.json, ai-podcast-radar/.codex-harness/progress/REQ-143/next-agent-brief.md, ai-podcast-radar/.codex-harness/progress/REQ-143/progress.md, ai-podcast-radar/.codex-harness/reports/goals/REQ-143.md, ai-podcast-radar/.codex-harness/reports/visual-review/latest.json, ai-podcast-radar/.codex-harness/reports/visual-review/latest.md, ai-podcast-radar/.codex-harness/state/active-goal.json, ai-podcast-radar/.codex-harness/state/agent-runs.jsonl, ai-podcast-radar/.codex-harness/state/goals/REQ-143.json",
        "created_at": "2026-06-05T02:11:55.150Z"
      },
      {
        "id": "blocker-1780625471506",
        "task_id": "REL-20260605-021110",
        "source": "release",
        "message": "Production deploy requires a clean worktree. Changed files: ai-podcast-radar/.codex-harness/reports/visual-review/latest.json, ai-podcast-radar/.codex-harness/reports/visual-review/latest.md, ai-podcast-radar/.codex-harness/state/agent-runs.jsonl, ai-podcast-radar/.codex-harness/state/budget-state.json, ai-podcast-radar/.codex-harness/state/cost-ledger.jsonl, ai-podcast-radar/apps/web/src/harness-snapshot.generated.ts, ai-podcast-radar/apps/web/src/home-data.generated.ts, ai-podcast-radar/package.json",
        "created_at": "2026-06-05T02:11:11.493Z"
      },
      {
        "id": "blocker-1780540246189",
        "task_id": "metrics-daily",
        "source": "metrics",
        "message": "Command failed: npm run metrics:fetch\n[metrics:fetch] Command failed: npx wrangler d1 execute METRICS_DB --remote --command SELECT COUNT(*) AS events_total, COUNT(DISTINCT path) AS paths_total, COUNT(DISTINCT COALESCE(NULLIF(target, ''), event_name)) AS targets_total FROM product_events WHERE unixepoch(occurred_at) >= unixepoch('now', '-7 days') --json\n(node:18803) ExperimentalWarning: CommonJS module /usr/local/lib/node_modules/npm/node_modules/debug/src/node.js is loading ES Module /usr/local/lib/node_modules/npm/node_modules/supports-color/index.js using require().\nSupport for loading ES Module in require() is an experimental feature and might change at any time\n(Use `node --trace-warnings ...` to show where the warning was created)\n\u001b[31m✘ \u001b[41;31m[\u001b[41;97mERROR\u001b[41;31m]\u001b[0m \u001b[1mFailed to write to log file Error: EPERM: operation not permitted, open '<local-path>'\u001b[0m\n\n      at async open (node:internal/fs/promises:639:25)\n      at async writeFile (node:internal/fs/promises:1209:14)\n      at async <local-path>\n      at async Mutex.runWith (<local-path>\n      at async appendToDebugLogFile (<local-path> {\n    errno: -1,\n    code: 'EPERM',\n    syscall: 'open',\n    path: '<local-path>'\n  }\n\n\n\u001b[31m✘ \u001b[41;31m[\u001b[41;97mERROR\u001b[41;31m]\u001b[0m \u001b[1mWould have written: \u001b[0m\n\n  --- 2026-06-04T02:30:45.994Z debug\n  🪵  Writing logs to \"<local-path>\"\n  ---\n  \n\n\n🪵  Logs were written to \"<local-path>\"\n\n",
        "created_at": "2026-06-04T02:30:46.189Z"
      },
      {
        "id": "blocker-1780453934099",
        "task_id": "metrics-daily",
        "source": "metrics",
        "message": "Command failed: npm run metrics:fetch\n[metrics:fetch] Command failed: npx wrangler d1 execute METRICS_DB --remote --command SELECT COUNT(*) AS events_total, COUNT(DISTINCT path) AS paths_total, COUNT(DISTINCT COALESCE(NULLIF(target, ''), event_name)) AS targets_total FROM product_events WHERE unixepoch(occurred_at) >= unixepoch('now', '-7 days') --json\n<local-path>\n          throw new Error(`\n          ^\n\nError: \nYou installed workerd on another platform than the one you're currently using.\nThis won't work because workerd is written with native code and needs to\ninstall a platform-specific binary executable.\n\nSpecifically the \"@cloudflare/workerd-darwin-64\" package is present but this platform\nneeds the \"@cloudflare/workerd-darwin-arm64\" package instead. People often get into this\nsituation by installing workerd on macOS and copying \"node_modules\"\ninto a Docker image that runs Linux.\n\nIf you are installing with npm, you can try not copying the \"node_modules\"\ndirectory when you copy the files over, and running \"npm ci\" or \"npm install\"\non the destination platform after the copy. Or you could consider using yarn\ninstead which has built-in support for installing a package on multiple\nplatforms simultaneously.\n\nIf you are installing with yarn, you can try listing both this platform and the\nother platform in your \".yarnrc.yml\" file using the \"supportedArchitectures\"\nfeature: https://yarnpkg.com/configuration/yarnrc/#supportedArchitectures\nKeep in mind that this means multiple copies of workerd will be present.\n\n    at generateBinPath (<local-path>\n    at Object.<anonymous> (<local-path>\n    at Module._compile (node:internal/modules/cjs/loader:1706:14)\n    at Object..js (node:internal/modules/cjs/loader:1839:10)\n    at Module.load (node:internal/modules/cjs/loader:1441:32)\n    at Function._load (node:internal/modules/cjs/loader:1263:12)\n    at TracingChannel.traceSync (node:diagnostics_channel:328:14)\n    at wrapModuleLoad (node:internal/modules/cjs/loader:237:24)\n    at Module.require (node:internal/modules/cjs/loader:1463:12)\n    at require (node:internal/modules/helpers:147:16)\n\nNode.js v22.22.0\n\n",
        "created_at": "2026-06-03T02:32:14.099Z"
      },
      {
        "id": "blocker-1780367496848",
        "task_id": "metrics-daily",
        "source": "metrics",
        "message": "Command failed: npm run metrics:fetch\n[metrics:fetch] Command failed: npx wrangler d1 execute METRICS_DB --remote --command SELECT COUNT(*) AS events_total, COUNT(DISTINCT path) AS paths_total, COUNT(DISTINCT COALESCE(NULLIF(target, ''), event_name)) AS targets_total FROM product_events WHERE unixepoch(occurred_at) >= unixepoch('now', '-7 days') --json\n<local-path>\n          throw new Error(`\n          ^\n\nError: \nYou installed workerd on another platform than the one you're currently using.\nThis won't work because workerd is written with native code and needs to\ninstall a platform-specific binary executable.\n\nSpecifically the \"@cloudflare/workerd-darwin-64\" package is present but this platform\nneeds the \"@cloudflare/workerd-darwin-arm64\" package instead. People often get into this\nsituation by installing workerd on macOS and copying \"node_modules\"\ninto a Docker image that runs Linux.\n\nIf you are installing with npm, you can try not copying the \"node_modules\"\ndirectory when you copy the files over, and running \"npm ci\" or \"npm install\"\non the destination platform after the copy. Or you could consider using yarn\ninstead which has built-in support for installing a package on multiple\nplatforms simultaneously.\n\nIf you are installing with yarn, you can try listing both this platform and the\nother platform in your \".yarnrc.yml\" file using the \"supportedArchitectures\"\nfeature: https://yarnpkg.com/configuration/yarnrc/#supportedArchitectures\nKeep in mind that this means multiple copies of workerd will be present.\n\n    at generateBinPath (<local-path>\n    at Object.<anonymous> (<local-path>\n    at Module._compile (node:internal/modules/cjs/loader:1706:14)\n    at Object..js (node:internal/modules/cjs/loader:1839:10)\n    at Module.load (node:internal/modules/cjs/loader:1441:32)\n    at Function._load (node:internal/modules/cjs/loader:1263:12)\n    at TracingChannel.traceSync (node:diagnostics_channel:328:14)\n    at wrapModuleLoad (node:internal/modules/cjs/loader:237:24)\n    at Module.require (node:internal/modules/cjs/loader:1463:12)\n    at require (node:internal/modules/helpers:147:16)\n\nNode.js v22.22.0\n\n",
        "created_at": "2026-06-02T02:31:36.848Z"
      },
      {
        "id": "blocker-1780281130363",
        "task_id": "metrics-daily",
        "source": "metrics",
        "message": "Command failed: npm run metrics:fetch\n[metrics:fetch] Command failed: npx wrangler d1 execute METRICS_DB --remote --command SELECT COUNT(*) AS events_total, COUNT(DISTINCT path) AS paths_total, COUNT(DISTINCT COALESCE(NULLIF(target, ''), event_name)) AS targets_total FROM product_events WHERE unixepoch(occurred_at) >= unixepoch('now', '-7 days') --json\n<local-path>\n          throw new Error(`\n          ^\n\nError: \nYou installed workerd on another platform than the one you're currently using.\nThis won't work because workerd is written with native code and needs to\ninstall a platform-specific binary executable.\n\nSpecifically the \"@cloudflare/workerd-darwin-64\" package is present but this platform\nneeds the \"@cloudflare/workerd-darwin-arm64\" package instead. People often get into this\nsituation by installing workerd on macOS and copying \"node_modules\"\ninto a Docker image that runs Linux.\n\nIf you are installing with npm, you can try not copying the \"node_modules\"\ndirectory when you copy the files over, and running \"npm ci\" or \"npm install\"\non the destination platform after the copy. Or you could consider using yarn\ninstead which has built-in support for installing a package on multiple\nplatforms simultaneously.\n\nIf you are installing with yarn, you can try listing both this platform and the\nother platform in your \".yarnrc.yml\" file using the \"supportedArchitectures\"\nfeature: https://yarnpkg.com/configuration/yarnrc/#supportedArchitectures\nKeep in mind that this means multiple copies of workerd will be present.\n\n    at generateBinPath (<local-path>\n    at Object.<anonymous> (<local-path>\n    at Module._compile (node:internal/modules/cjs/loader:1706:14)\n    at Object..js (node:internal/modules/cjs/loader:1839:10)\n    at Module.load (node:internal/modules/cjs/loader:1441:32)\n    at Function._load (node:internal/modules/cjs/loader:1263:12)\n    at TracingChannel.traceSync (node:diagnostics_channel:328:14)\n    at wrapModuleLoad (node:internal/modules/cjs/loader:237:24)\n    at Module.require (node:internal/modules/cjs/loader:1463:12)\n    at require (node:internal/modules/helpers:147:16)\n\nNode.js v22.22.0\n\n",
        "created_at": "2026-06-01T02:32:10.363Z"
      },
      {
        "id": "blocker-1779845592942",
        "task_id": "REQ-100",
        "source": "radar-ready-executor",
        "message": "perl -e 'alarm 45; exec @ARGV' node scripts/integrations/feishu/write-release-status.mjs --requirement REQ-100 --status in_progress --clear-blocker --agent data --task-id REQ-100 --run-status passed --checks feishu_requirement_writeback timed out after 45s; tool exit code -1",
        "created_at": "2026-05-27T01:33:12.930Z"
      }
    ]
  },
  "cost": {
    "month_to_date_usd": 0,
    "today_usd": 0,
    "week_usd": 0,
    "budget_usd": 100,
    "alert_threshold_usd": 80,
    "pause_threshold_usd": 90,
    "by_agent": {
      "release": 0,
      "intake_pm": 0,
      "radar-ready-executor": 0,
      "metrics": 0,
      "requirement_drafter": 0,
      "requirement_reviewer": 0,
      "requirement_publisher": 0,
      "intake-pm": 0,
      "data": 0,
      "engineer": 0,
      "followup_proposer": 0,
      "ceo": 0,
      "requirement_quality_loop": 0,
      "product": 0
    },
    "ledger_entries": 1150
  },
  "content": {
    "cases": {
      "total": 15,
      "by_status": {
        "draft": 10,
        "published": 5
      }
    },
    "insights": {
      "total": 25,
      "by_status": {
        "draft": 20,
        "published": 5
      }
    },
    "podcasts": {
      "configured": true,
      "total": 30
    },
    "episodes": {
      "configured": true,
      "total": 0,
      "processed": 0
    }
  },
  "releases": [
    {
      "id": "REL-20260616-REQ177-PDF-SEMANTIC",
      "kind": "task-release",
      "status": "released",
      "completed_at": "2026-06-16T12:25:46.609Z",
      "requirement_ids": [
        "REQ-177"
      ],
      "req_count": 1,
      "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/luo-yonghao-crossroads/",
      "git_commit": "7d86603e7078ba0e25da78c151ec35c9fc7e4535",
      "agent_authored": false
    },
    {
      "id": "REL-20260616-091538",
      "kind": "release",
      "status": "approved",
      "completed_at": "2026-06-16T09:15:45.536Z",
      "requirement_ids": [
        "REQ-176"
      ],
      "req_count": 1,
      "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/luo-yonghao-crossroads/",
      "git_commit": "7d86603e7078ba0e25da78c151ec35c9fc7e4535",
      "agent_authored": false
    },
    {
      "id": "REL-20260616-091538",
      "kind": "task-release",
      "status": "qa_passed",
      "completed_at": "2026-06-16T09:14:18.614Z",
      "requirement_ids": [
        "REQ-176"
      ],
      "req_count": 1,
      "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/luo-yonghao-crossroads/",
      "git_commit": "7d86603e7078ba0e25da78c151ec35c9fc7e4535",
      "agent_authored": false
    },
    {
      "id": "REL-20260609-100617",
      "kind": "task-release",
      "status": "qa_passed",
      "completed_at": "2026-06-16T01:31:55.502Z",
      "requirement_ids": [
        "REQ-001"
      ],
      "req_count": 1,
      "production_url": "",
      "git_commit": "",
      "agent_authored": false
    },
    {
      "id": "REL-20260609-100617",
      "kind": "task-release",
      "status": "qa_passed",
      "completed_at": "2026-06-16T01:31:55.502Z",
      "requirement_ids": [
        "REQ-002"
      ],
      "req_count": 1,
      "production_url": "",
      "git_commit": "",
      "agent_authored": false
    },
    {
      "id": "REL-20260609-100617",
      "kind": "task-release",
      "status": "qa_passed",
      "completed_at": "2026-06-16T01:31:55.502Z",
      "requirement_ids": [
        "REQ-003"
      ],
      "req_count": 1,
      "production_url": "",
      "git_commit": "",
      "agent_authored": false
    },
    {
      "id": "REL-20260609-100617",
      "kind": "task-release",
      "status": "qa_passed",
      "completed_at": "2026-06-16T01:31:55.502Z",
      "requirement_ids": [
        "REQ-004"
      ],
      "req_count": 1,
      "production_url": "",
      "git_commit": "",
      "agent_authored": false
    },
    {
      "id": "REL-20260609-100617",
      "kind": "task-release",
      "status": "qa_passed",
      "completed_at": "2026-06-16T01:31:55.502Z",
      "requirement_ids": [
        "REQ-006"
      ],
      "req_count": 1,
      "production_url": "",
      "git_commit": "",
      "agent_authored": false
    }
  ],
  "acceptance": {
    "total": 108,
    "accepted": 44,
    "accepted_with_risk": 45,
    "blocked": 3,
    "latest": [
      {
        "id": "ACPT-REQ-177-REL-20260616-REQ177-PDF-SEMANTIC",
        "requirement_id": "REQ-177",
        "release_id": "REL-20260616-REQ177-PDF-SEMANTIC",
        "conclusion": "accepted",
        "generated_at": "2026-06-16T12:25:46.611Z",
        "markdown": "docs/product/acceptance/REQ-177-REL-20260616-REQ177-PDF-SEMANTIC.md",
        "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/luo-yonghao-crossroads/",
        "github_pr": "",
        "checks_passed": 21,
        "checks_total": 21
      },
      {
        "id": "ACPT-REQ-176-REL-20260616-091538",
        "requirement_id": "REQ-176",
        "release_id": "REL-20260616-091538",
        "conclusion": "accepted_with_risk",
        "generated_at": "2026-06-16T09:15:45.542Z",
        "markdown": "docs/product/acceptance/REQ-176-REL-20260616-091538.md",
        "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/luo-yonghao-crossroads/",
        "github_pr": "",
        "checks_passed": 19,
        "checks_total": 19
      },
      {
        "id": "ACPT-REQ-176-REL-20260616-091401",
        "requirement_id": "REQ-176",
        "release_id": "REL-20260616-091401",
        "conclusion": "blocked",
        "generated_at": "2026-06-16T09:14:18.616Z",
        "markdown": "docs/product/acceptance/REQ-176-REL-20260616-091401.md",
        "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/luo-yonghao-crossroads/",
        "github_pr": "",
        "checks_passed": 15,
        "checks_total": 15
      },
      {
        "id": "ACPT-REQ-174-REL-20260615-235019",
        "requirement_id": "REQ-174",
        "release_id": "REL-20260615-235019",
        "conclusion": "accepted_with_risk",
        "generated_at": "2026-06-15T23:50:45.081Z",
        "markdown": "docs/product/acceptance/REQ-174-REL-20260615-235019.md",
        "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/luo-yonghao-crossroads/episodes/68a3d1fe293471fed44ce974/",
        "github_pr": "",
        "checks_passed": 21,
        "checks_total": 21
      },
      {
        "id": "ACPT-REQ-174-REL-20260615-234903",
        "requirement_id": "REQ-174",
        "release_id": "REL-20260615-234903",
        "conclusion": "blocked",
        "generated_at": "2026-06-15T23:49:15.474Z",
        "markdown": "docs/product/acceptance/REQ-174-REL-20260615-234903.md",
        "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/luo-yonghao-crossroads/episodes/68a3d1fe293471fed44ce974/",
        "github_pr": "",
        "checks_passed": 12,
        "checks_total": 12
      },
      {
        "id": "ACPT-REQ-173-REL-REQ-173-20260615-TRANSCRIPTS",
        "requirement_id": "REQ-173",
        "release_id": "REL-REQ-173-20260615-TRANSCRIPTS",
        "conclusion": "accepted",
        "generated_at": "2026-06-15T13:00:43.071Z",
        "markdown": "docs/product/acceptance/REQ-173-REL-REQ-173-20260615-TRANSCRIPTS.md",
        "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/luo-yonghao-crossroads/",
        "github_pr": "",
        "checks_passed": 20,
        "checks_total": 20
      },
      {
        "id": "ACPT-REQ-171-REL-REQ-171-20260611-0139",
        "requirement_id": "REQ-171",
        "release_id": "REL-REQ-171-20260611-0139",
        "conclusion": "accepted",
        "generated_at": "2026-06-11T06:23:06.469Z",
        "markdown": "docs/product/acceptance/REQ-171-REL-REQ-171-20260611-0139.md",
        "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/?filter=chinese",
        "github_pr": "",
        "checks_passed": 16,
        "checks_total": 16
      },
      {
        "id": "ACPT-REQ-170-REL-20260610-REQ170-42ZHANGJING",
        "requirement_id": "REQ-170",
        "release_id": "REL-20260610-REQ170-42ZHANGJING",
        "conclusion": "accepted",
        "generated_at": "2026-06-10T14:06:12.575Z",
        "markdown": "docs/product/acceptance/REQ-170-REL-20260610-REQ170-42ZHANGJING.md",
        "production_url": "https://ai-podcast-radar-web.pages.dev/podcasts/42zhangjing/",
        "github_pr": "",
        "checks_passed": 16,
        "checks_total": 16
      }
    ]
  },
  "mvp_alpha": {
    "task_a_passed": true,
    "task_d_passed": true,
    "local_smoke_passed": true,
    "engineer_alpha_runs": 10,
    "note": "Local smoke proves the repo-level Harness plumbing. Live MVP-alpha still needs GitHub PR, Feishu writeback, production deploy, and 24-hour unattended evidence."
  }
} as const;
export type HarnessSnapshot = typeof harnessSnapshot;
